import React, { useState } from 'react';
import cx from 'classnames';
import './SpotLights.css';
import Rodal from 'rodal';
import Starthree from '../../assets/images/starthree.png';
import Starfor from '../../assets/images/starfor.png';

function SpotLights({ data: {
  hidePrices, campaignsTitle,
  termAndServiceLinkText,
  termAndServiceLinkTitle,
  userTermsContent,
  hideTermConditions
}, className, children, onShareClick, onGotoTC, onTrackState, onTrackAction, ...otherProps }) {
  // const [showTerm, setShowTerm] = useState(false);
  // const toggleTerms = () => {
  //   if (showTerm) {
  //     document.body.classList.remove('modal-open');
  //   } else {
  //     onTrackAction && onTrackAction('HarmonyTAndC', JSON.stringify({ 'link.category': 'HarmonyLanding' }));
  //     onTrackState && onTrackState('tools/harmony/termsandconditions');
  //     document.body.classList.add('modal-open');
  //   }
  //   setShowTerm(!showTerm);
  // };

  const nopClose = () => { };

  return <div className="ha-spot-wrap">
      <img className="starthree" src={Starthree} alt="" />
      <img className="starfor" src={Starfor} alt="" />
    {!hidePrices ? (
      <div className={cx('ha-spotlights-root', className)} {...otherProps}>
        <h4>{campaignsTitle}</h4>
        <div className='spotlight-wrapper'>
          {children}
        </div>
        {/* {
          !hideTermConditions && <div className='user-terms' onClick={toggleTerms}>
            {termAndServiceLinkText} <i className='di di16 di-next-2' />
          </div>
        } */}

      </div>
    ) : <div className={cx('ha-spotlights-root', className)}>
      {/* <Rodal width={100} height={100} measure='%' showCloseButton={false} onClose={nopClose}
      animation='fullScreenUp'
      visible={showTerm}>
      <div className='modal-container'>
        <header>
          <i className='di di16 di-previous' onClick={toggleTerms} />
          <h1>{termAndServiceLinkText}</h1>
        </header>
        <div className='modal-content'>
          <div className='raw-html-contents' dangerouslySetInnerHTML={{ __html: userTermsContent.replace(/\n/g, '<br />') }} />
        </div>
      </div>
    </Rodal> */}
    </div>
    }
    {
      !hideTermConditions ? (
        <div className="user-terms-box">
          <div className="user-terms-title">{termAndServiceLinkTitle}</div>
          <div className='user-terms' onClick={onGotoTC}>
            {termAndServiceLinkText} <i className='di di12 di-next-2' />
          </div>
        </div>
      ) : null
    }
    <div className="h30"></div>
  </div>

}
export default SpotLights;
